import {adminHttpClient} from "../commons/adminHttpClient";


const deleteSubject = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/AuditableSubjects/Delete`, {
        data:{id : id}
    })
}

export default deleteSubject;